/* ============================================================
   Höchstbestellwert — verhindert das Hinzufügen, wenn der Warenkorb dadurch darüber käme.

   Betrifft nur Länder mit Obergrenze; derzeit die Schweiz mit 999,99 €. Der Wert kommt aus
   snippets/cart-schwellen.liquid und steht als data-max am Balken im Header. Ist er 0,
   tut dieses Skript gar nichts.

   ── Warum VOR dem Hinzufügen und nicht danach ──────────────────────────────────────
   Shopify kennt keinen Höchstbestellwert. Ein Artikel, der die Grenze reißt, würde also
   angenommen, und man müsste ihn hinterher wieder entfernen — der Warenkorb flackerte
   sichtbar. Deshalb wird der Absendeversuch abgefangen und der Betrag vorher gerechnet.

   ── Woher der Preis kommt ──────────────────────────────────────────────────────────
   Der Preis der gewählten Variante steht je nach Stelle woanders:
     Produktseite      im JSON von variant-selects [data-selected-variant]
     Shop-Kachel       als data-base-price am Kaufen-Knopf
     Varianten-Pop-up  als data-variant-price an der gewählten Pille

   Findet sich keiner dieser Werte, wird NICHT blockiert. Das ist Absicht: Lieber einmal
   zu viel durchlassen, als jemanden ohne erkennbaren Grund am Kaufen zu hindern. Die
   Grenze greift dann immer noch im Warenkorb selbst, wo der Kasse-Knopf gesperrt wird.
   ============================================================ */
(function () {
  'use strict';

  function ganzzahl(wert) {
    var n = parseInt(wert, 10);
    return isNaN(n) ? 0 : n;
  }

  // Preis der gerade gewählten Variante in Cent, oder 0 wenn nicht ermittelbar.
  function preisAus(form) {
    var info = form.closest('product-info');
    if (info) {
      var json = info.querySelector('variant-selects [data-selected-variant]');
      if (json) {
        try {
          var variante = JSON.parse(json.textContent);
          if (variante && typeof variante.price === 'number') return variante.price;
        } catch (e) { /* kaputtes JSON: wie „nicht ermittelbar“ behandeln */ }
      }
    }

    var pille = form.querySelector('.card-variant-pill.is-selected[data-variant-price]');
    if (pille) return ganzzahl(pille.getAttribute('data-variant-price'));

    var knopf = form.querySelector('[data-base-price], [data-vq-baseprice]');
    if (knopf) {
      return ganzzahl(knopf.getAttribute('data-base-price') || knopf.getAttribute('data-vq-baseprice'));
    }

    return 0;
  }

  function mengeAus(form) {
    var feld = form.querySelector('[name="quantity"]');
    var n = feld ? parseInt(feld.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function init() {
    var balken = document.querySelector('[data-header-cart-bar]');
    if (!balken) return;

    var MAX = ganzzahl(balken.dataset.max);
    if (MAX <= 0) return;   // Land ohne Obergrenze — nichts zu tun

    var zone = document.querySelector('.header__icons');

    // Kurz rot aufleuchten und den Hinweis vorübergehend austauschen. Danach kehrt beides
    // von selbst zurück: Die Klasse nimmt die Animation am Ende weg, und den Text setzt
    // header-cart-bar.js bei der nächsten Warenkorbänderung ohnehin neu — hier wird er
    // zusätzlich nach Ablauf zurückgeholt, falls gar keine Änderung mehr kommt.
    function warnen() {
      var textEl = document.querySelector('[data-hcb-text]');
      var vorher = textEl ? textEl.textContent : null;

      if (balken) {
        balken.classList.remove('is-max-warnung');
        void balken.offsetWidth;
        balken.classList.add('is-max-warnung');
      }
      // Das gelbe Aufblinken abraeumen, falls es gerade laeuft: Hier wurde NICHTS
      // hinzugefuegt, gelb waere die falsche Rueckmeldung neben der roten Warnung.
      if (zone) zone.classList.remove('is-cart-flash');
      if (textEl) textEl.textContent = 'Maximaler Bestellwert erreicht';

      window.setTimeout(function () {
        if (textEl && textEl.textContent === 'Maximaler Bestellwert erreicht' && vorher !== null) {
          textEl.textContent = vorher;
        }
      }, 4000);
    }

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.closest || !form.closest('product-form')) return;

        var preis = preisAus(form);
        if (preis <= 0) return;   // nicht ermittelbar: durchlassen

        var aktuell = ganzzahl(balken.dataset.total);
        if (aktuell + preis * mengeAus(form) <= MAX) return;

        event.preventDefault();
        event.stopPropagation();
        warnen();
      },
      true   // capture: vor Dawns eigenem Verarbeiter am Formular
    );

    // Den zuletzt bekannten Warenkorbwert mitführen — data-total ist sonst der Stand vom
    // Seitenaufbau und veraltet, sobald jemand etwas hinzufügt, ohne die Seite zu wechseln.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var data = event && event.cartData;
        if (data && typeof data.total_price === 'number') balken.dataset.total = data.total_price;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
